<div class="messages-container">
	<div class="message" *ngFor="let message of messages; trackBy: trackByFn_messages"
		[ngClass]="{ 'is-current-user': message.senderUserID && message.senderUserID === currentUserId }"
		#message id="message-{{ message.id }}">
		<div class="message-avatar" [ngStyle]="message | avatarColours">
			<div class="message-avatar-text" [innerHTML]="message | avatarText"></div>
		</div>
		<div class="message-bubble-and-status-container">
			<div class="message-bubble">
				<div class="message-header">
					<div class="person">
						{{
							(message.senderUserID && message.senderUserID === currentUserId 
								? ("CHAT_MESSAGES.SENDER_IS_YOU_LABEL" | translate) 
								: message.senderUserName ?? ("CHAT_MESSAGES.UNKNOWN_SENDER_LABEL" | translate))
						  + (message.senderCompanyId ? " (" + publisher?.label + ")" : "")
						}}
					</div>
					<div class="timestamp">
						{{ message.timestamp | cassTimestamp }}
					</div>
				</div>
				<div class="message-text">{{ message.messageText }}</div>
			</div>
			<ng-container *ngIf="(sending$ | async) as sendingState">
				<div class="message-send-status" *ngIf="!message.id && (sendingState === 'SENDING' || sendingState === 'ERROR')">
					<cass-indeterminate-circular-progress-indicator class="sending-spinner" *ngIf="sendingState === 'SENDING'"></cass-indeterminate-circular-progress-indicator>
					<div>{{ (sendingState === "SENDING" ? "CHAT_MESSAGES.CHAT_PANEL.SENDING_STATUS" : sendingState === "ERROR" ? "CHAT_MESSAGES.CHAT_PANEL.SEND_FAILED" : "") | translate }}</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>
<div class="new-message-wrapper">
	<mat-form-field appearance="fill" subscriptSizing="dynamic">
		<mat-label>{{ "CHAT_MESSAGES.CHAT_PANEL.TYPE_YOUR_MESSAGE_HERE" | translate }}</mat-label>
		<textarea 
			matInput
			[(ngModel)]="newMessageText"
			cdkTextareaAutosize
			#autosize="cdkTextareaAutosize"
			cdkAutosizeMinRows="1"
			>
		</textarea>
	</mat-form-field>
	<button mat-icon-button color="primary" [disabled]="!newMessageText || (sending$ | async) === 'SENDING'" (click)="requestSendMessage()">
        <mat-icon>send</mat-icon>
    </button>
</div>
